import Generate from '../../generator/generate';

const SocketParticipants = async () => {
  await Generate();
};

export default SocketParticipants;